import { TransitionLink } from "@/components/shell/TransitionLink";
import { whatsappUrl, type WhatsappContext } from "@/content/whatsapp";
import styles from "./ui.module.css";

type Props = {
  href: string;
  children: React.ReactNode;
  /** "primary" es la píldora con borde de luz; por defecto, link de texto. */
  variant?: "text" | "primary";
  className?: string;
};

// Link de acción del sitio. Las rutas internas viajan con la transición del mundo; las
// externas abren en otra pestaña con su marca de salida.
export function CtaLink({ href, children, variant = "text", className }: Props) {
  const cls = [variant === "primary" ? styles.primary : styles.cta, className].filter(Boolean).join(" ");
  const external = /^https?:\/\//.test(href);
  if (external) {
    return (
      <a href={href} className={cls} target="_blank" rel="noopener" data-external={variant === "text" ? "true" : undefined}>
        {children}
      </a>
    );
  }
  if (href.startsWith("mailto:")) {
    return (
      <a href={href} className={cls}>
        {children}
      </a>
    );
  }
  return (
    <TransitionLink href={href} className={cls}>
      {children}
    </TransitionLink>
  );
}

/** CTA de WhatsApp con el mensaje armado según el contexto (guía 12.1). */
export function WhatsappCta({
  context = "general",
  children,
  variant = "primary",
}: {
  context?: WhatsappContext;
  children: React.ReactNode;
  variant?: "text" | "primary";
}) {
  return (
    <a
      href={whatsappUrl(context)}
      className={variant === "primary" ? styles.primary : styles.cta}
      target="_blank"
      rel="noopener"
      data-external={variant === "text" ? "true" : undefined}
    >
      {children}
    </a>
  );
}

export function mailto(subject: string, email = "admin@yvyrai.lat") {
  return `mailto:${email}?subject=${encodeURIComponent(subject)}`;
}
